/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllergyDto
 */
export interface AllergyDto {
    /**
     * 
     * @type {string}
     * @memberof AllergyDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllergyDto
     */
    name?: string | null;
}

export function AllergyDtoFromJSON(json: any): AllergyDto {
    return AllergyDtoFromJSONTyped(json, false);
}

export function AllergyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllergyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AllergyDtoToJSON(value?: AllergyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

